// [etichetta italiana, valore salvato] — il secondo elemento è il valore
// memorizzato nel database e non va mai modificato.
export const PropertyOptions = {
    exterior: [
        ["Stanze Totali", "Total Rooms"],
        ["Letto Singolo", "Single Bed"],
        ["Letto Matrimoniale", "Double Bed"],
        ["Divano Letto Singolo", "Single Sofa Bed"],
        ["Divano Letto Doppio", "Double Sofa Bed"],
        ["Letto a Castello Singolo", "Single Bunk Bed"],
        ["Letto a Castello Doppio", "Double Bunk Bed"],
        ["Lettino Singolo", "Single Cot"],
        ["Lettino Doppio", "Double Cot"],
        ["Balcone", "Balcony"],
        ["Terrazza", "Terrace"],
        ["Giardino", "Garden"],
        ["Piscina", "Pool"],
        ["Parcheggio", "Parking"],
        ["Garage", "Garage"],
        ["Terrazza sul Tetto", "Roof Terrace"],
        ["Cucina", "Kitchen"],
        ["Soggiorno", "Living Room"],
        ["Sala da Pranzo", "Dining Room"],
        ["Bagno", "Bathroom"],
        ["Bagno con Doccia", "Bathroom with Shower"],
        ["Ripostiglio", "Storage"],
        ["Studio", "Office"],
        ["Biblioteca", "Library"],
        ["Palestra", "Gym"],
        ["Sauna", "Sauna"],
        ["Jacuzzi", "Jacuzzi"],
        ["Bagno Turco", "Steam Room"],
        ["Cinema", "Cinema"],
        ["Sala Giochi", "Games Room"],
        ["Bar", "Bar"],
        ["Cantina", "Wine Cellar"],
        ["Lavanderia", "Laundry Room"],
        ["Locale Tecnico", "Utility Room"],
    ],
    appliance: [
        ["Aria Condizionata", "Air Conditioning"],
        ["TV", "TV"],
        ["Caldaia", "Boiler"],
        ["Frigorifero", "Fridge"],
        ["Mini Frigo", "Mini Fridge"],
        ["Congelatore", "Freezer"],
        ["Forno", "Oven"],
        ["Microonde", "Microwave"],
        ["Lavastoviglie", "Dishwasher"],
        ["Lavatrice", "Washing Machine"],
        ["Asciugatrice", "Dryer"],
        ["Macchina da Caffè", "Coffee Machine"],
        ["Bollitore", "Kettle"],
        ["Tostapane", "Toaster"],
        ["Ferro da Stiro", "Iron"],
        ["Asciugacapelli", "Hair Dryer"],
        ["Aspirapolvere", "Vacuum Cleaner"],
        ["Riscaldamento", "Heating"],
        ["Riscaldamento a Pavimento", "Underfloor Heating"],
        ["Termostato", "Thermostat"],
    ],
    facilities: [
        ["Internet Wi-Fi", "Wi-fi Internet"],
        ["Tende", "Curtains"],
        ["Cucina", "Kitchen"],
        ["Contatore", "Meter"],
    ]
};

// Etichetta italiana per un valore salvato (usata in sola lettura, es. scheda proprietà).
export const propertyOptionLabel = (group, value) => {
    const match = (PropertyOptions[group] || []).find((option) => option[1] === value);
    return match ? match[0] : value;
};
